
// Format EX Show Variants on Collection titles.
// Displays the product name on the first line
// and the variant name on the second line.

  document.addEventListener('DOMContentLoaded', () => {
    const formatVariantTitles = () => {
      document
        .querySelectorAll('.product-title[data-eosh-variant-url]')
        .forEach((title) => {
          if (title.dataset.titleFormatted === 'true') return;

          const text = title.textContent.trim();
          const separatorIndex = text.lastIndexOf(' - ');

          if (separatorIndex === -1) return;

          const productName = text.slice(0, separatorIndex).trim();
          const variantName = text.slice(separatorIndex + 3).trim();

          title.innerHTML = `
            <span class="eosh-product-name">${productName}</span>
            <span class="eosh-variant-name">${variantName}</span>
          `;

          title.dataset.titleFormatted = 'true';
        });
    };

    formatVariantTitles();

    const observer = new MutationObserver(formatVariantTitles);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
